module.exports = __webpack_public_path__ + "img/m42_55s_thumb.914c5d11.jpg";